import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRisk360 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M17.158 6.213c.672.31 1.192.958 1.192 1.76-.03 3.089-1.284 8.679-6.54 11.242-.52.247-1.1.247-1.62 0-5.257-2.564-6.51-8.153-6.54-11.241 0-.803.52-1.452 1.192-1.76l5.745-2.471c.123-.031.275-.093.428-.093.122 0 .275.062.397.093zM5.942 10.568h5.073V5.719L5.636 8.035c0 .741.092 1.606.306 2.533m10.116 0h-5.043v6.825c3.056-1.483 4.493-4.324 5.043-6.825"
    />
  </svg>
);
export default SvgRisk360;
